<script>
import {
  CdrGrid,
  CdrText,
  CdrButton,
} from '@rei/cedar';
import analytics from '../../common/analytics';

export default {
  name: 'GiftcardBulkComponent',
  components: {
    CdrGrid,
    CdrText,
    CdrButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    ctaBulk: {
      type: Object,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      analytics,
    };
  },
  computed: {
    validProps() {
      return (this.title && this.description && (typeof this.ctaBulk !== 'undefined'));
    },
  },
  methods: {
    sendClick() {
      const name = 'shop corporate gift cards';
      this.analytics.click({
        linkName: `${this.siteId}:${this.pageDescription}_${name}`,
      });
    },
  },
};
</script>

<template>
  <cdr-grid
    v-if="validProps"
    class="giftcard-bulk__container container-static"
    gutter="medium"
    data-ui="bulk-content"
  >
    <cdr-text
      class="giftcard-bulk__title"
      tag="h2"
      data-ui="gift-card-heading-company-section"
    >
      {{ title }}
    </cdr-text>
    <cdr-text
      class="giftcard-bulk__description"
      tag="p"
      data-ui="gift-card-company-information"
    >
      {{ description }}
    </cdr-text>
    <cdr-button
      class="giftcard-bulk__button"
      tag="a"
      :href="ctaBulk.urlBulk"
      modifier="secondary"
      data-ui="btn-shop-corporate"
      @click="sendClick"
    >
      {{ ctaBulk.name }}
    </cdr-button>
  </cdr-grid>
</template>
